module.exports = __webpack_public_path__ + "Roboto-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.ttf
// module id = 91
// module chunks = 0